/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmIdentity",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: "I declare that the information I have provided in this form is complete and correct. I understand that giving false or misleading information is a serious offence."
      }
    ]
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.FORM.ACTIONS,
    buttons: [
      {
        label: "Previous",
        size: "large",
        appearance: "secondary",
        prefix: "chevronLeft",
        action: "form:previous",
        skippable: true
      },
      {
        label: "Create account",
        size: "large",
        appearance: "primary",
        action: "form:next"
      }
    ]
  }
];